import React from "react";
import Spacer from "../Spacer";
import Stack from "../Stack";
import Typography from "../Typography";
import { Button as StyledButton, ButtonStyleProps } from "./Button-styles";

interface PropTypes extends ButtonStyleProps {
  children?: React.ReactNode;
  onPress?: () => void;
}

function detectNormalButton({ outline, fill }) {
  if (outline) {
    return `${outline}.main`;
  } else if (fill === "white") {
    return "primary.main";
  } else if (fill) {
    return "common.white";
  }
  return;
}
function detectDisabledButton({ disabled, outline, fill }) {
  if (disabled && outline) {
    return "neutrals.300";
  } else if (disabled && fill === "white") {
    return "neutrals.300";
  } else if (disabled && fill) {
    return "common.white";
  } else if (disabled) {
    return "common.white";
  }
  return;
}

function detectTextColor(
  { outline, fill, disabled },
  defaultTextColor?: string
) {
  if (disabled) {
    return detectDisabledButton({ outline, fill, disabled });
  } else {
    return defaultTextColor || detectNormalButton({ outline, fill });
  }
}

function Button(props: PropTypes) {
  let {
    children,
    onPress,
    size = "m",
    // @ts-ignore farzad will fix
    fill,
    // @ts-ignore farzad will fix
    outline,
    disabled,
    textColor,
    fs = "m",
    radius,
    ...styleProps
  } = props;

  if (!outline && !fill) {
    fill = "primary";
  }
  if (fill && typeof fill === "boolean") {
    fill = "primary";
  }
  if (outline && typeof outline === "boolean") {
    outline = "primary";
  }
  if (fill === "white") {
    fill = "white";
  }

  return (
    <StyledButton
      fill={fill}
      outline={outline}
      size={size}
      disabled={disabled}
      onPress={onPress}
      radius={radius}
      {...styleProps}
    >
      <Stack distribution="center">
        {/* @ts-ignore farzad will fix */}
        {props.prefix}
        {/* @ts-ignore farzad will fix */}
        {props.prefix ? <Spacer size="s" /> : null}
        <Typography
          alignment="center"
          ff="mainBold"
          fs={fs}
          color={detectTextColor({ outline, fill, disabled }, textColor)}
        >
          {props.children}
        </Typography>
        {/* @ts-ignore farzad will fix */}
        {props.suffix ? <Spacer size="s" /> : null}
        {/* @ts-ignore farzad will fix */}
        {props.suffix}
      </Stack>
    </StyledButton>
  );
}

export default Button;
